const siteConfig = {
  brandName: "teingshome",
  displayName: "teingshome",
  legalName: "HONG KONG HONGTUO SHENG TRADING CO., LIMITED",
  tagline: "Thoughtful living · Beautifully considered",
  description:
    "Everyday homeware, gifts and easy essentials selected for calm, colourful living.",
  currency: "USD",
  currencySymbol: "$",
  shipping: { flatRate: 9.99 },
  contact: {
    address: "RM 10, UNIT 12A, 13/F, BLK 1, CAMEL PAINT BUILDING, 62 HOI YUEN ROAD, KWUN TONG, HONG KONG",
    email: "export@teingshome.shop",
  },
};

export default siteConfig;
